module.exports = __webpack_public_path__ + "static/pexels-8-2a9d4a6af99d7853697d1f6c0cdc2318.png";